<template>
  <div class="content">
    <h3>Surveillance des fraudes</h3>
    <!-- Filters Section -->
    <div class="card">
      <div class="card-body">
        <div class="row">
          <base-input class="col-md-4">
            <el-date-picker
              v-model="filters.start_date"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="Start Date"
            ></el-date-picker>
          </base-input>
          <base-input class="col-md-4">
            <el-date-picker
              v-model="filters.end_date"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="End Date"
            ></el-date-picker>
          </base-input>
          <base-input class="col-md-4">
            <el-input
              v-model="filters.pv"
              placeholder="TAG"
              clearable
            ></el-input>
          </base-input>
        </div>
        <div class="col-xs-4 text-right mt-3">
           <button
            class="btn btn-market mr-2"
            @click="DownloadCSV"
          >
            <i class="tim-icons icon-cloud-download-93"></i> EXPORT CSV
          </button>
          <base-button
            v-if="loading"
            loading
            class="btn btn-default"
          >
            Loading...
          </base-button>
          <button
            v-else
            class="btn btn-default"
            @click="fetchFraudList"
          >
            Recherche
          </button>
        </div>
      </div>
    </div>

    <card>
      <div class="row">
        <div class="col-xl-1 col-sm-6">
          <base-input>
            <el-select
              class="select-primary pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </base-input>
        </div>
        <div class="col-xl-8 col-sm-6">
          <label style="margin-top: 10px; font-size: 0.75rem">Lines per page</label>
        </div>
        <base-input class="col-xl-3 col-sm-6">
          <el-input
            type="search"
            class="mb-3 search-input"
            clearable
            prefix-icon="el-icon-search"
            placeholder="Recherche"
            v-model="searchQuery"
          ></el-input>
        </base-input>
      </div>


      <el-table
        :data="paginatedFraudList"
        v-loading="loading"
        row-class-name="fraud-table-rows"
        class="customtable"
        style="width: 100%;"
      >
        <!-- Product Column -->
        <el-table-column prop="product" label="Produit" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.product || 'N/A'" :open-delay="300" placement="top">
              <span>{{ row.product || 'N/A' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Page Views (pv) - Takes Full Width --
        <el-table-column prop="pv" label="Tag">
          <template #default="{ row }">
            <el-tooltip :content="row.pv" :open-delay="300" placement="top">
              <span>{{ row.pv }}</span>
            </el-tooltip>
          </template>
        </el-table-column> -->

        <!-- Email -->
        <el-table-column prop="email" label="E-mail" width="200" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.email || 'N/A'" :open-delay="300" placement="top">
              <span>{{ row.email || 'N/A' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- IP Address -->
        <el-table-column prop="ip" label="Adresse IP" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.ip" :open-delay="300" placement="top">
              <span>{{ row.ip_address }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- IP Address -->
        <el-table-column prop="pv" label="Tag" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.pv" :open-delay="300" placement="top">
              <span>{{ row.pv }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Created At -->
        <el-table-column prop="created_at" label="Créé Le" width="180" sortable>
          <template #default="{ row }">
            <el-tooltip :content="new Date(row.created_at).toLocaleString()" :open-delay="300" placement="top">
              <span>{{ new Date(row.created_at).toLocaleString() }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- City from IP Info -->
        <el-table-column prop="city_ipinfo" label="Ville" width="120" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.city_ipinfo" :open-delay="300" placement="top">
              <span>{{ row.city_ipinfo }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Region from IP Info -->
        <el-table-column prop="region_ipinfo" label="Région" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.region_ipinfo" :open-delay="300" placement="top">
              <span>{{ row.region_ipinfo }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Organization from IP Info -->
        <el-table-column prop="org_ipinfo" label="Organisation" width="200" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.org_ipinfo || 'N/A'" :open-delay="300" placement="top">
              <span>{{ row.org_ipinfo || 'N/A' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Screen -->
        <el-table-column prop="screen" label="Résolution" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.screen" :open-delay="300" placement="top">
              <span>{{ row.screen }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- Platform -->
        <el-table-column prop="platform" label="Plateforme" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.platform" :open-delay="300" placement="top">
              <span>{{ row.platform }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- User Agent -->
        <el-table-column prop="user_agent" label="User Agent" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.user_agent" :open-delay="300" placement="top">
              <span>{{ row.user_agent ? `${row.user_agent.slice(0,50)}...` :  '' }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <!-- time_spent -->
        <el-table-column prop="time_spent" label="Temps de remplissage" width="150" sortable>
          <template #default="{ row }">
            <el-tooltip :content="row.time_spent" :open-delay="300" placement="top">
              <span>{{ row.time_spent }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>


      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div>
          <p class="card-category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>
        <base-pagination
          type="warning"
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        ></base-pagination>
      </div>
    </card>
  </div>
</template>

<script>
import axios from "axios";
import { Table, TableColumn, Select, Option, Input , DatePicker} from "element-ui";
import { BaseButton, BasePagination } from "src/components";
import XLSX from 'xlsx';

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    BaseButton,
    [DatePicker.name]: DatePicker,

    BasePagination,
  },
  data() {
    const today = new Date().toISOString().split('T')[0]; // Format: YYYY-MM-DD

    return {
      fraudList: [],
      loading: false,
      filters : {
        start_date  : today,
        end_date  : today,
        pv  : '',
      },
      searchQuery: "",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [50, 100, 250, 500],
      },
    };
  },
  computed: {
    filteredFraudList() {
      if (!this.searchQuery) return this.fraudList;
      return this.fraudList.filter((item) =>
        JSON.stringify(item).toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedFraudList() {
      const start = this.from;
      const end = this.to;
      return this.filteredFraudList.slice(start, end);
    },
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return Math.min(this.pagination.currentPage * this.pagination.perPage, this.total);
    },
    total() {
      return this.filteredFraudList.length;
    },
  },
  methods: {
    async fetchFraudList() {
      this.loading = true;
      let accessToken = localStorage.getItem("token_jwt");
      const apiUrl = "https://apileadmarket.wee-do-it.net/api/mongustave-fraude-list";

      try {
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          params: this.filters
        });


        this.fraudList = response.data;
      } catch (error) {
        console.error("Error fetching fraud list:", error);
        this.$notify({
          type: "danger",
          message: "Failed to fetch data. Please try again.",
        });
      } finally {
        this.loading = false;
      }
    },
    DownloadCSV() {
      let FraudData = JSON.parse(JSON.stringify(this.fraudList))
      FraudData.forEach(ele => {
        // delete Attribute
      })
      const fileName = `Surveillance_des_fraudes.csv`
      var CSVData = XLSX.utils.json_to_sheet(FraudData)
      CSVData = XLSX.utils.sheet_to_csv(CSVData, {FS:";"});

      var blob = new Blob(["\ufeff", CSVData]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }
  },
  mounted() {
    this.fetchFraudList();
  },
};
</script>

<style scoped>
.content {
  padding: 20px;
}

.fraud-table-rows {
  text-transform: capitalize;
}

.customtable {
  word-break: break-word;
}
</style>
